import React from 'react';
import styled, { css } from 'styled-components';
import { forDesktop, forIE } from '@westwing/ui-kit/breakPoints';
import { AspectRatio } from '@westwing/ui-kit/AspectRatio';
import { PortraitBanner } from '../../redux/homepage/types';
import Banner from '../Generic/Banner';
import useGa from '../../hooks/useGa';
import { changePreformattedImageProperties } from '../../hooks/useImageFormatter';
import { homePagePortraitBannerRatios } from '../../constants/aspectRatios';
import { BannerText } from './SecondaryBanner';
import { BannerTrackingVariations } from 'Common/ga/homepage';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';

interface PortraitBannersProps {
    portraitBanners: PortraitBanner[];
}

const StyledWrapper = styled.div`
    padding: 25px 20px 0;
    ${forDesktop`
        padding: 25px 20px 0;
    `}
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
`;

const StyledContainer = styled.div<{ p100IncreasedDesktopPageWidth?: boolean }>`
    width: 100%;
    ${forDesktop`
          width: calc((100% - 20px) / 3);
    `}
    ${forIE`
        max-height: 640px;
    `}
    ${({ p100IncreasedDesktopPageWidth }) =>
        p100IncreasedDesktopPageWidth &&
        css`
            ${forIE`
                 max-height: 720px;
            `}
        `}
`;

const StyledBannerText = styled(BannerText)`
    padding-top: 5px;
`;

const StyledBanner = styled(Banner)`
    ${AspectRatio}
`;

const PortraitBanners: React.FC<PortraitBannersProps> = ({ portraitBanners = [] }) => {
    const gaTracking = useGa();
    const { p100IncreasedDesktopPageWidth } = useFeatureToggle();
    const getTrackingFn = (id: string) => gaTracking.homepage.getBannerTrackingFn(BannerTrackingVariations.General, id);

    const handleBannerImpression = (trackingName: string) => {
        gaTracking.homepage.trackBannerImpression(trackingName);
    };

    return (
        <StyledWrapper>
            {portraitBanners.map(banner => {
                const formattedCmsForMobile = changePreformattedImageProperties(banner.image, {
                    height: '892',
                });

                return (
                    <StyledContainer p100IncreasedDesktopPageWidth={p100IncreasedDesktopPageWidth} key={banner.title}>
                        <StyledBanner
                            ratio={homePagePortraitBannerRatios}
                            desktopImage={banner.image}
                            mobileImage={formattedCmsForMobile}
                            targetUrl={banner.targetUrl}
                            trackingFn={getTrackingFn(banner.trackingName)}
                            shouldLazyLoadBanner
                            trackImpressionFunction={() => handleBannerImpression(banner.trackingName)}
                        />
                        <StyledBannerText {...banner} />
                    </StyledContainer>
                );
            })}
        </StyledWrapper>
    );
};

export default PortraitBanners;
